<script lang="ts">
import {
  ref,
  provide,
  defineComponent,
} from 'vue';

import { useNotifications } from '@thehotelsnetwork/lampo';

import { PageContext } from '@/types';

export default defineComponent({
  name: 'NkPage',
  props: {
    loading: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const isPageLoading = ref(props.loading);
    const { showNotification } = useNotifications();

    provide(PageContext, {
      isPageLoading,
      showNotification,
    });

    return {
      isPageLoading,
    };
  },
});
</script>
<template>
  <div class="h-full">
    <slot
      v-if="loading"
      name="loading"
      :props="{ loading }"
    >
      <div
        class="fixed inset-0 flex items-center justify-center w-full max-w-3xl m-auto"
      >
        <LpLoader
          class="text-primary-500"
          ring-size="50"
        />
      </div>
    </slot>
    <template v-else>
      <slot
        name="title"
      >
        <h1
          v-if="title"
          class="title1 mb-5"
        >
          {{ title }}
        </h1>
      </slot>

      <main class="h-full">
        <slot />
      </main>
    </template>
  </div>
</template>
